import { render, staticRenderFns } from "./associateDevice.vue?vue&type=template&id=5ca004f0&scoped=true&"
import script from "./associateDevice.vue?vue&type=script&lang=js&"
export * from "./associateDevice.vue?vue&type=script&lang=js&"
import style0 from "./associateDevice.vue?vue&type=style&index=0&id=5ca004f0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca004f0",
  null
  
)

export default component.exports